import React, { useContext } from 'react';
import img from '../../../assets/Img';
import { LocalizationContext } from '../../../context/LangChange';
import { Col, Row } from 'react-bootstrap';
import '../seo.css';

const translations = {
  en: require('../../../Translate/en.json').WebsiteDevelopment2.ServiceHome,
  ar: require('../../../Translate/ar.json').WebsiteDevelopment2.ServiceHome,
};

const WebsiteServiceHome = () => {
  const { isLang } = useContext(LocalizationContext);
  const t = translations[isLang || 'en'];

  const data = [
    {
      image: img.sIcon1,
      short_title: t.php.title,
      short_description: t.php.description,
    },
    {
      image: img.sIcon6,
      short_title: t.wordpress.title,
      short_description: t.wordpress.description,
    },
    {
      image: img.sIcon5,
      short_title: t.enterprise.title,
      short_description: t.enterprise.description,
    },
    {
      image: img.sIcon2,
      short_title: t.ecommerce.title,
      short_description: t.ecommerce.description,
    },
    {
      image: img.sIcon3,
      short_title: t.webApps.title,
      short_description: t.webApps.description,
    },
    {
      image: img.sIcon4,
      short_title: t.javascript.title,
      short_description: t.javascript.description,
    },
  ];

  return (
    <div className='app__service_home m-0 overflow-hidden'>
      <section className='services_container'>
        <Row className='servicess_mt'>
          {data.map((item, index) => (
            <Col
              key={index}
              xl={4}
              lg={4}
              md={6}
              sm={12}
              className={`${index + 1 > 3 ? 'p-2' : 'mt-2 '} border service_${index + 1}`}
              dir={isLang === 'ar' ? 'rtl' : 'ltr'}
            >
              <div className="services_content flex flex-column justify-content-between h-100 p-4 py-6">
                <div className="icons">
                  <img width={50} height={50} src={item.image} className="w-100" alt="" />
                </div>
                <span>{item.short_title}</span>
                <div className={isLang === 'en' ? 'list' : 'list_ar'}>
                  <ul>
                    {item.short_description.map((desc, i) => (
                      <li key={i}>{desc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </section>
    </div>
  );
};

export default WebsiteServiceHome;
